import React, { useState, useEffect, useRef, useContext, useLayoutEffect  } from 'react';
import { useLocalStorage } from '_context/commonHooks';
import { MapContext } from '_context/MapContext';

import { PlaceList, AddrResult, AddrList } from 'component/PlaceList';


export const RPHistoryCom = ({setRPFromHistory}) => {
	// const [history, setHistory] = useLocalStorage('GIS_HistoryList',window.localStorage.getItem('GIS_HistoryList') || []);
	
	// let tempArr2 = []
	// if(window.localStorage.getItem('GIS_RPList')){
	// 	tempArr2 = JSON.parse(window.localStorage.getItem('GIS_RPList')).filter((element) => {
	// 		let check = false
	// 		if(element.rp && element.rp.start && element.rp.start.point && element.rp.end && element.rp.start.end){
	// 			check = true
	// 		}else{
	// 			return false
	// 		}
	// 		if(element.rp && element.rp.wayPoints){
	// 			element.rp.wayPoints.filter((wayPoint) => {
	// 				if(!wayPoint['point']){
	// 					check = false
	// 				}
	// 			})
	// 		}
	// 		if(check){
	// 			return element
	// 		}
	// 	})
	// }
	// const [RPhistory, setRPhistory] = useLocalStorage('GIS_RPList',tempArr2 || []);

	const {history, setHistory, RPhistory, setRPhistory} = useContext(MapContext);
	const [arrHistory, setArrHistory] = useState([...history,...RPhistory]);
	arrHistory.sort(function(a,b){
		return b.timestamp - a.timestamp
	})

	useEffect(() => {
		setArrHistory([...history,...RPhistory])
		arrHistory.sort(function(a,b){
			return b.timestamp - a.timestamp
		})
		
	},[history, RPhistory])

	const RPHistoryList = (item,i) => {
		 return (
			<a key={i} onClick={()=>setRPFromHistory(JSON.parse(JSON.stringify(item.rp)),"rp")}>
			<span className="sticker ic2 bg2"></span>
			<span className="txt1">{item.rp.start?item.rp.start.keyword:''} → {item.rp.end?item.rp.end.keyword:''}</span>
			</a>
		 )
	 }

	const POIHistoryList = (item,i) => {
		return (
			<a key={i} onClick={()=>setRPFromHistory(item,"anything")}>
			<span className="sticker ic3 bg3"></span>
			<span className="txt1">{item.name}</span>
			</a>
		)
	}

	const deleteHistory = () => {
		setHistory('allDelete')
		setRPhistory('allDelete')
		setArrHistory([])
	}

	return (
		<React.Fragment>
		<div className="myPoint">
		<button className="btnHome"><span className="iconsNavi"></span><span>집</span></button>
		<a href="#">등록</a>
		<button className="btnOffice"><span className="iconsNavi"></span><span>직장</span></button>
		<a href="#">수정</a>
	</div>
	<div className="recentSch">
	<div className="title">최근검색/길찾기<span onClick={()=>deleteHistory()} style={{left:190}}>전체삭제</span></div>
	<div className="list">
	{
		arrHistory.map((item,i)=> item.rp?RPHistoryList(item,i):POIHistoryList(item,i))	              
	}


</div>
	</div>
	</React.Fragment>
	)
}

export const RPSearchResult = ({data,addrData,pages, mode, target, setHistory,setRoutePoi,onChangePages}) => {

  const [addrBlock, setAddrBlock] = useState(true);
  const { selectedId } = useContext(MapContext);

  if(data.length<1 && addrData.length<1){  return null}

    return (

        <div>
        {
          pages.addrTotal > 0 &&  <div className={addrBlock?"wrapAddress":"wrapAddress hide"} >
		  <AddrResult addrData={addrData} addrTotal={pages.addrTotal} addrBlock={addrBlock} setAddrBlock={setAddrBlock}  setHistory={setHistory}
		  mode={mode} target={target} setRoutePoi={setRoutePoi}  /></div>     
        }
        <div className="wrapPlace">
		<div  className={
			"wrapTop " +
			(pages.addrTotal > 0 ?"":"onlyPoi ")
		  }>
			<div className="resultNum">장소 <span className="num">{pages.pageTotal}</span>건 <span className="iconsArrow"></span></div>
			<div className="sort">
				<ul>
					<li><button className={pages.sort==="relevance"?"on":""} onClick={() => onChangePages("sort","relevance")} ><span>관련도순</span></button></li>
					<li><button className={pages.sort==="distance"?"on":""} onClick={() => onChangePages("sort","distance")}><span>거리순</span></button></li>
				</ul>
      </div>
{/*  <div className="btnWrap">
					<button className="btnToggle"><span className="btnsSch close"></span></button>
				</div> */}
        </div> 

        <div className="list">
        <ul>
		{data.map((row,i)=><PlaceList key={i} idx={i} obj={row} isActive={selectedId===row.id?true:false} 
		setHistory={setHistory} mode={mode} target={target} setRoutePoi={setRoutePoi} />)}               
        </ul></div>

        </div>


        </div>
       
    );
  };
  